import { useMemo } from 'react';
import { getProduto } from 'config/produto-env';
import { useAuth } from 'context/AuthContext';
import { EtapaCronograma, montarCronograma } from 'utils/cronograma';

/** Cronograma da home do produto, a partir das datas que o AuthContext já carrega. */
export function useCronograma(): EtapaCronograma[] {
  const { controlDates } = useAuth();
  return useMemo(() => montarCronograma(controlDates ?? [], getProduto()), [controlDates]);
}
